import { useCallback, useEffect, useState } from 'react';

async function apiRequest(apiBase, path, options = {}) {
  const response = await fetch(`${apiBase}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.ok) {
    throw new Error(payload.message || 'Request failed');
  }
  return payload;
}

function AdmissionsAdminPanel({ apiBase }) {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const loadApplications = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiRequest(apiBase, '/admin/admissions/applications');
      setApplications(res.data || []);
    } catch (err) {
      setError(err.message || 'Failed to load admissions applications');
    } finally {
      setLoading(false);
    }
  }, [apiBase]);

  useEffect(() => {
    loadApplications();
  }, [loadApplications]);

  async function setStatus(id, status) {
    setSaving(true);
    setError('');
    try {
      await apiRequest(apiBase, `/admin/admissions/applications/${id}`, {
        method: 'PUT',
        body: JSON.stringify({ status_code: status, admin_note: '' }),
      });
      await loadApplications();
    } catch (err) {
      setError(err.message || 'Failed to update status');
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="super-admin-card">
      <h3>Admissions Admin Queue</h3>
      {error && <div className="alert alert-error">{error}</div>}
      {loading && <div className="alert alert-info">Loading admissions data...</div>}

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Level</th>
              <th>Status</th>
              <th>Submitted At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {applications.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.applicant_name}</td>
                <td>{item.applicant_email}</td>
                <td>{item.level_code}</td>
                <td>{item.status_code}</td>
                <td>{item.created_at}</td>
                <td>
                  <button type="button" onClick={() => setStatus(item.id, 'in_review')} disabled={saving}>Review</button>
                  <button type="button" onClick={() => setStatus(item.id, 'approved')} disabled={saving}>Approve</button>
                  <button type="button" onClick={() => setStatus(item.id, 'rejected')} disabled={saving}>Reject</button>
                </td>
              </tr>
            ))}
            {!applications.length && !loading && (
              <tr>
                <td colSpan={7}>No admissions applications available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default AdmissionsAdminPanel;
